import { render, staticRenderFns } from "./chateau-monbousquet.vue?vue&type=template&id=0c474bd5&scoped=true"
import script from "./chateau-monbousquet.vue?vue&type=script&lang=js"
export * from "./chateau-monbousquet.vue?vue&type=script&lang=js"
import style0 from "./chateau-monbousquet.vue?vue&type=style&index=0&id=0c474bd5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c474bd5",
  null
  
)

export default component.exports